// splitterNode.js - Splits data into multiple outputs

import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';

export const SplitterNode = ({ id, data }) => {
  const handles = [
    { id: 'input', type: 'target', position: Position.Left },
    { id: 'output1', type: 'source', position: Position.Right, top: 25 },
    { id: 'output2', type: 'source', position: Position.Right, top: 50 },
    { id: 'output3', type: 'source', position: Position.Right, top: 75 }
  ];

  return (
    <BaseNode
      id={id}
      data={data}
      title="Splitter"
      description="Split data into 3 outputs"
      handleConfig={handles}
      width={180}
      height={140}
    />
  );
};
